var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLcRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1102_1139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8059 10.9519C12.8059 11.4864 12.3906 11.9303 11.8714 11.9303H0.943137C0.423979 11.9303 0 11.4864 0 10.9519C0 10.4173 0.423979 9.96436 0.943137 9.96436H11.8628C12.3819 9.96436 12.7972 10.4083 12.7972 10.9519H12.8059Z",
    fill: "#243D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5586 17.7556C13.9221 18.1361 13.9221 18.7612 13.5586 19.1508L13.3596 19.3592C12.9962 19.7397 12.3559 19.785 12.0012 19.4045C11.8195 19.2142 11.7243 18.9696 11.7243 18.7159C11.7243 18.4622 11.8195 18.2086 12.0012 18.0183L12.2434 17.7646C12.6069 17.3841 13.2039 17.3841 13.5673 17.7646L13.5586 17.7556Z",
    fill: "#243D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10.9517C21 11.2054 20.9049 11.4591 20.7318 11.6403L16.2151 16.3695C15.8517 16.75 15.2547 16.75 14.8826 16.3695C14.5192 15.989 14.5192 15.3639 14.8826 14.9743L18.733 10.9427L11.9926 3.87602C11.8109 3.69483 11.7158 3.4502 11.7158 3.18747C11.7158 2.92473 11.8109 2.68013 11.9926 2.48987C12.1657 2.30868 12.3993 2.19995 12.6502 2.19995C12.9012 2.19995 13.1348 2.30868 13.3165 2.48987L20.7318 10.2541C20.9049 10.4353 21 10.689 21 10.9517Z",
    fill: "#243D63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1102_1139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcRightarrow);
export default __webpack_public_path__ + "static/media/LCRightarrow.3b3a889dd2b650e5f66ae6e90f608969.svg";
export { ForwardRef as ReactComponent };